import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { AngularEditorConfig } from '@kolkov/angular-editor/lib/config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { countryReference } from 'src/app/utils/constants/strings';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';

@Component({
  selector: 'app-email-configeration',
  templateUrl: './email-configeration.component.html',
  styleUrls: ['./email-configeration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailConfigerationComponent implements OnInit {
  labelName: string;
  dialogData: any;
  configData: any;
  index;
  preAlertEmailForm: FormGroup;
  emailArray;
  destinationCountryCode: string;
  destinationCountryList = countryReference;
  selectedPreReportParams: any = [];
  preReportParams: Observable<string[]>;
  filteredCountry = countryReference;

  preAlertConfigertion: any;
  isValidCountry: boolean = true;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '350px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: false,
  };

  constructor(
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<EmailConfigerationComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data.labelName != null) {
      this.labelName = data.labelName;
      this.dialogData = data;
      this.index = data.index;
    }
  }

  ngOnInit(): void {
    this.initializForm();
    this.getReportparams();

    setTimeout(() => {
      this.destinationCountryList = countryReference;
    }, 0);

    this.countrySearchInitialise();

    if (this.dialogData.labelName == 'Edit') {
      this.preAlertEmailForm.patchValue(this.dialogData.mappingData);
      this.selectedPreReportParams = this.dialogData.mappingData.reportparams;
      this.destinationCountryCode = this.destinationCountryList.find(
        con => con.name === this.dialogData.mappingData.Destination
      ).code;
      this.preAlertEmailForm.get('Destination').disable();
    }
    this.configData = this.dialogData.configData;
  }

  countrySearchInitialise() {
    this.preAlertEmailForm.get('Destination').valueChanges.subscribe(newValue => {
      const currCity = this.filteredCountry.some(con => con.name == newValue.trim());
      if (newValue && !currCity) {
        this.isValidCountry = false;
      } else {
        this.isValidCountry = true;
      }
      this.destinationCountryList = this.filteredCountry.filter(
        value => value?.name.toLowerCase().indexOf(newValue.toLowerCase()) === 0
      );
    });
  }

  initializForm() {
    this.preAlertEmailForm = this.fb.group({
      email: new FormControl('', Validators.email),
      Destination: new FormControl('', Validators.required),
      EmailList: new FormControl('', Validators.required),
      reportparams: new FormControl('', Validators.required),
      emailContent: new FormControl('', Validators.required),
      senderEmail: new FormControl({ value: environment.senderEmail, disabled: true }),
      companyName: new FormControl('', Validators.required),
      commercialInvoice: new FormControl(false),
      babyDestServiceCode: new FormControl('', Validators.required),
    });
  }

  sendCommercialInvoice(checked) {
    this.preAlertEmailForm.get('commercialInvoice').setValue(checked);
  }

  getReportparams() {
    this.configService.fetchConfig('prealert_reportparams').then(res => {
      this.preReportParams = res.data;
      this.emailArray = this.dialogData.mappingData.EmailList;
    });
  }

  savePreConfig(config) {
    this.configService.saveConfig(config).subscribe(() => {
      this.dialogRef.close('true');
      if (this.labelName == 'Create') {
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.addressComponentSave?.message,
          basicSnackBarConfig.addressComponentSave?.horizontalPosition,
          basicSnackBarConfig.addressComponentSave?.verticalPosition,
          basicSnackBarConfig.addressComponentSave?.duration
        );
      } else {
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.addressComponentUpdate?.message,
          basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
          basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
          basicSnackBarConfig.addressComponentUpdate?.duration
        );
      }
      this.configService.putConfig(config.config_id, config.data);
    });
  }

  closeDailog() {
    this.dialogRef.close();
  }

  saveConfig() {
    let config: any = [];
    const configData: any = {};
    if (this.configData?.data) {
      config = this.configData.data;
    } else {
      configData.config_id = 'prealert_emails';
    }
    const formData = (this.preAlertEmailForm as FormGroup).getRawValue();
    const countryIndex = config.findIndex(x => x.Destination == this.destinationCountryCode);
    if (countryIndex > -1 && config.length > 0) {
      const serviceCodeIndex = config.findIndex(
        x => x.babyDestServiceCode == formData.babyDestServiceCode
      );
      if (serviceCodeIndex > -1) {
        config[serviceCodeIndex].Destination = this.destinationCountryCode;
        config[serviceCodeIndex].babyDestServiceCode = formData.babyDestServiceCode;
        config[serviceCodeIndex].EmailList = formData.EmailList;
        config[serviceCodeIndex].reportparams = formData.reportparams;
        config[serviceCodeIndex].emailContent = formData.emailContent.trim();
        config[serviceCodeIndex].companyName = formData.companyName.trim();
        config[serviceCodeIndex].commercialInvoice = formData.commercialInvoice;
        config[serviceCodeIndex].senderEmail = formData.senderEmail;
      } else {
        const contryCodeObj: any = {};
        contryCodeObj.Destination = this.destinationCountryCode;
        contryCodeObj.babyDestServiceCode = formData.babyDestServiceCode;
        contryCodeObj.EmailList = formData.EmailList;
        contryCodeObj.reportparams = formData.reportparams;
        contryCodeObj.emailContent = formData.emailContent.trim();
        contryCodeObj.companyName = formData.companyName.trim();
        contryCodeObj.commercialInvoice = formData.commercialInvoice;
        contryCodeObj.senderEmail = formData.senderEmail;
        config.push(contryCodeObj);
      }
    } else {
      const contryCodeObj: any = {};
      contryCodeObj.Destination = this.destinationCountryCode;
      contryCodeObj.babyDestServiceCode = formData.babyDestServiceCode;
      contryCodeObj.EmailList = formData.EmailList;
      contryCodeObj.reportparams = formData.reportparams;
      contryCodeObj.emailContent = formData.emailContent.trim();
      contryCodeObj.companyName = formData.companyName.trim();
      contryCodeObj.commercialInvoice = formData.commercialInvoice;
      contryCodeObj.senderEmail = formData.senderEmail;
      config.push(contryCodeObj);
    }
    if (!this.configData?.data) {
      configData.data = config;
      this.savePreConfig(configData);
    } else {
      this.savePreConfig(this.configData);
    }
  }

  destinationCountryselectionChanged(eventVal: string) {
    if (eventVal != '') {
      this.destinationCountryCode = this.destinationCountryList.find(
        con => con.name === eventVal
      ).code;
    }
  }

  addEmailIdToList() {
    const newEmail = this.preAlertEmailForm.get('email').value.trim();
    const newEmailLowercase = newEmail.toLowerCase();
    if (newEmail) {
      if (this.emailArray && this.emailArray.length > 0) {
        const existingEmail = this.emailArray.find(
          email => email.toLowerCase() === newEmailLowercase
        );
        if (!existingEmail) {
          this.emailArray.push(newEmail);
          this.preAlertEmailForm.get('email').setValue('');
        } else {
          this.errorDialogService.openDialog('alert.emailExist', false);
        }
      } else {
        this.emailArray = [];
        this.emailArray.push(newEmail);
        this.preAlertEmailForm.get('email').setValue('');
      }
      this.preAlertEmailForm.get('EmailList').patchValue(this.emailArray);
    }
  }
}
